import styled from 'styled-components';

import { PageContentContainer } from '~src/styles/containers.sc';

export const PageContentContainerS = styled(PageContentContainer)`
  padding-bottom: 30px;
  position: relative;
`;
// Postponed: Select all items
// export const ToggleSelectAllBox = styled.div`
//   display: flex;
//   margin: 30px 0 0 30px;
// `;

export const ListContainer = styled.div`
  position: relative;
`;

export const InfoSortingBlock = styled.div<{ $isLoading?: boolean }>`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
`;

export const ItemsListContainer = styled.div`
  margin-top: 15px;
`;

export const NoItemsText = styled.div`
  font-size: 1rem;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin: 60px auto;
`;

export const ImportBtnsBox = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
`;

export const SummaryContainer = styled.div`
  margin-top: 30px;
`;

export const ProgressBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 80px;
`;
